import React from 'react';
import {Page, StyleSheet, Text, View} from '@react-pdf/renderer';
import FoldLabelHorizontal from "./FoldLabelHorizontal";
import {convertYMDtoDMY} from "../../utils/dateTimeUtils";
import {
    getBorderStyle, getCircledLetterStyles,
    getDarkBrandColor, getDisembarkInstructions,
    getFoldDoNotCutText,
    getLabelColor,
    getStandardInstructions, getWheelchairInstructions
} from "../../utils/themePdfUtils";
import LuggageTagInstructions from "./LuggageTagInstructions";
import {getLoginPageTexts} from "../../utils/themeUtils";
import WheelchairImage from "./WheelchairImage";


// Create styles
const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: 'white',
        fontFamily: "pdfFont",
    },
});

export const LuggageTagPage = (props) => {
    const containerStyle = {
        height: "50%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
    };

    return(
        <Page size="A4" style={styles.page}>
            <View style={{...containerStyle, borderBottom: getBorderStyle()}}>
                <EmptyPart border={true} />

                <FoldLabelVertical />

                <View style={{height: "100%", flex:1, textAlign: "center", borderRight: getBorderStyle(), display: "flex", justifyContent: "flex-end"}}>
                    {props.mainContentTop}
                </View>

                <FoldLabelVertical />

                <View style={{height: "100%", flex:1, textAlign: "center", borderRight: getBorderStyle(), display: "flex", justifyContent: "center"}}>
                    <LuggageTagInstructions
                        instructions={props.isWheelchair ? getWheelchairInstructions() :
                            props.type==="disembarkation" ?
                                getDisembarkInstructions() :
                                getStandardInstructions()}
                    />
                </View>

                <FoldLabelVertical />

                <EmptyPart label={props.tagLabel} />
            </View>

            <FoldLabelHorizontal 
                offsets={[
                    {side: "left", value: "8%"},
                    {side: "left", value: "33%"},
                    {side: "right", value: "33%"},
                    {side: "right", value: "8%"},
                ]} 
            />

            <View style={containerStyle}>
                <EmptyPart letter="A" border={true} />

                <FoldLabelVertical />

                <View style={{height: "100%", flex:1, textAlign: "center", borderRight: getBorderStyle()}}>
                    {props.mainContentBottom}
                </View>

                <FoldLabelVertical />

                <EmptyPart letter="C" border={true} />

                <FoldLabelVertical />

                <EmptyPart label={props.tagLabel} letter="D" />
            </View>
        </Page>
    )
}


export const InfoPart = (props) => {
    const containerStyle = {}
    if(props.rotate) {
        containerStyle.transform = "rotate(180deg)";
    }

    const guestName = `${props.passenger.title} ${props.passenger.firstName} ${props.passenger.lastName}`;
    const deckNr = props.passenger.deckNumber;
    const cabinNr = props.passenger.cabinNumber;
    const port = props.bookingData.departurePortName;
    const departureDate = convertYMDtoDMY(props.bookingData.embarkationDate);
    const texts = getLoginPageTexts();

    return (
        <View style={containerStyle}>
            <View style={{padding: "24px 12px 12px 12px",}}>
                <View style={{backgroundColor: "#092a5e"}}>
                    <Text style={{color: "white", textTransform: "uppercase", fontSize: "13px", paddingVertical: "4px"}}>
                        {texts.title}
                    </Text>
                </View>
                <View style={{backgroundColor: "#c2e6fa", padding: "8px 6px 0px 6px"}}>
                    <TextWithLabel label="Guest name" value={guestName} rows={3}/>
                    <TextWithLabel label="Ship" value={props.bookingData.shipName} rows={2}/>
                    <TextWithLabel label="Cruise departure date" value={departureDate}/>
                    <TextWithLabel label="Departure port" value={port} rows={2}/>
                    <TextWithLabel label="Deck number" value={deckNr}/>
                    <TextWithLabel label="Cabin number" value={cabinNr} rows={2}/>
                </View>
            </View>
            <View style={{paddingTop: "6px", backgroundColor: "#fee100", textAlign: "center"}}>
                <Text style={{
                    textTransform: "uppercase", color: getDarkBrandColor(), fontSize: "9px", fontWeight: "bold"
                }}>
                    Staple or tape here
                </Text>
                <CircledLetter letter={props.stepLetter}/>
            </View>
        </View>
    )
}

export const WheelchairContent = props => (
    <View style={{
        position: "relative",
        flex: 1,
        alignItems: "center",
        transform: `rotate(${props.rotate ? "0": "180"}deg)`,
    }}>
        <View style={{
            width: "50px",
            height: "50px",
            transform: `rotate(90deg)`,
            marginTop: props.rotate ? "5px" : "13px",
            marginBottom: "35px",
        }}>
            <WheelchairImage />
        </View>

        <Text style={{
            color: "white",
            textTransform: "uppercase",
            fontSize: "36px",
            fontWeight: "bold",
            transform: `rotate(90deg)`,

        }}>
            {props.text}
        </Text>
    </View>

)


const EmptyPart = (props) => {
    const style = {
        height: "100%",
        flex:1,
    }

    if(props.border) {
        style.borderRight = getBorderStyle();
    }

    if(props.letter) {
        style.display = "flex";
        style.justifyContent = "flex-end";
    }

    if(props.label) {
        style.position = "relative"
    }

    return (
        <View style={style}>
            {props.label &&
            <View style={{position: "absolute", top: 0, bottom: 0, left:0, right: 0, display: "flex", alignItems: "center", justifyContent: "center"}}>
                <Text style={{
                    transform: "rotate(90deg)",
                    fontSize: props.label.length > 11 ? "36px" : "42px",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    width: "350px",
                    textAlign: "center",
                    color: getLabelColor(),
                }}>
                    {props.label}
                </Text>
            </View>}
            {props.letter && <CircledLetter letter={props.letter}/>}
        </View>
    );
}

export const CircledLetter = (props) => (
    <View style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2px", textAlign: "center"}}>
        <Text style={{
            width: "18px",
            height: "18px",
            borderRadius: 100,
            fontWeight: "bold",
            display: "absolute",
            bottom: 0,
            marginBottom: props.reduceBottomMargin ? "6px" : "16px",
            ...getCircledLetterStyles(props.color),
        }}>
            {props.letter}
        </Text>
    </View>
)

const TextWithLabel = (props) => {
    return (
        <View style={{backgroundColor: "white", padding: "4px", marginBottom: "6px"}}>
            <Text style={{textTransform: "uppercase", fontSize: "8px", fontWeight: "bold"}}>
                {props.label}:
            </Text>
            <Text style={{
                marginTop: "2px",
                fontSize: props.fontSize || "12px",
                height: (props.rows || 1) * 14 + "px",
            }}>
                {props.value}
            </Text>
        </View>
    )
}

export const CustomTextWithLabel = (props) => {
    let fontSize = "12px";
    const textLength = props.value?.length;
    if(textLength < 6) {
        fontSize = props.maxFontSize ? props.maxFontSize : "18px";
    }
    if(textLength > 30) {
        fontSize = "9px";
    }
    return (
        <View style={{backgroundColor: "white", padding: "4px", marginBottom: "6px", flex: props.flex, display: "flex"}}>
            {props.label &&
                <Text style={{textTransform: "uppercase", fontSize: "7px"}}>
                    {props.label}
                </Text>
            }
            <Text style={{
                marginTop: "2px",
                fontSize: fontSize,
                flex: 1,
                ...props.style
            }}>
                {props.value}
            </Text>
        </View>
    )
}

const FoldLabelVertical = (props) => {
    const noCutStyle = {
        width: "66px",
        height: "8px",
        textAlign: "center",
        position: "absolute",
        backgroundColor: "white",
        textTransform: "uppercase",
        fontWeight: "bold",
        transform: "rotate(90deg)",
        letterSpacing: "0.4px",
        top: "0px", 
        left: "-34.25px",
        fontSize: "5px",
        color: getDarkBrandColor()
    }

    return (
        <View style={{
            position: "relative",
            height: 0,
        }}>
            <Text style={{...noCutStyle}}>
                {getFoldDoNotCutText()}
            </Text>
        </View>
    );
}
